import React, { useState } from "react";
import { GoogleMap, useLoadScript, InfoWindow, Marker } from "@react-google-maps/api";
import { mapStyles } from "../google/constants"; 
import HTMLReactParser from 'html-react-parser';
import { Link } from "@StarberryUtils";
import _ from "lodash";
import marker_icon from "../images/map-marker.svg";
import "../styles/_index.scss";

const LocationMap = (props) => {
  const containerStyle = {
    width: "100%",
    height: props.height,
  };

  const center = {
    lat: props.lat,
    lng: props.lng,
  };

  const [currentInfo, setCurrentInfo] = useState(null);
  const { isLoaded } = useLoadScript({
    id: 'google-map-script',
    googleMapsApiKey: process.env.GATSBY_MAPS_API_KEY,
  });

  const onMarkerClick = (index) => {
    setCurrentInfo(index === currentInfo ? null : index);
  };

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={11}
      options={{
        styles: mapStyles,
        mapTypeControl: false,
        streetViewControl: false,
      }}
    >
      {props.locations.map((location, index) => (
        <Marker
          key={index}
          position={{ lat: location.lat, lng: location.lng }}
          icon={marker_icon}
          onClick={() => onMarkerClick(index)}
          marker={true}
        />
      ))}

      {props.locations.map((location, index) => (
        currentInfo === index && (
          <InfoWindow
            key={index}
            position={{ lat: location.lat, lng: location.lng }}
            onCloseClick={() => setCurrentInfo(null)}
            options={{
              pixelOffset: new window.google.maps.Size(0, -30),
            }}
          >
            <div className="marker-tooltip-wrap">

              {!_.isEmpty(location.image) && (
                <div className="marker-image img-zoom">
                <img
                  loading="lazy"
                  src={location.image[0]?.url}
                  alt={location.image[0]?.alt || location.title}
                  width="100%"
                />
                </div>
              )}
              <div className="marker-info">
                    <h6 className="h7"><Link href={location?.url}>{location.title}</Link></h6>
                    {location.address && (
                      <div className="marker-address text-xs">
                        {HTMLReactParser(location.address.replace(/<br\s*\/?>/gi, ''))}
                        <Link href={location?.Url} className="map-view-link text-sm-bold">View Details</Link>
                      </div>
                    )}
              </div>
            </div>
          </InfoWindow>
        )
      ))}
    </GoogleMap>
  ) : <></>;
};

export default React.memo(LocationMap);